import { Component } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { ButtonComponent } from '../../components/button/button.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-country-form-page',
  imports: [HeaderComponent,TextInputComponent,ButtonComponent,RouterLink],
  templateUrl: './country-form-page.component.html',
  styleUrl: './country-form-page.component.css'
})
export class CountryFormPageComponent {

}
